function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getValidElementProps } from '../utils/htmlValidProps';

require('xps-style/core/card.css');

var Card = function Card(props) {
  var kind = props.kind,
      children = props.children,
      className = props.className,
      hover = props.hover;
  var divProps = getValidElementProps('div', props);
  var classNames = cx({
    card: true,
    'card--nohover': hover === false,
    'card--outlined': kind === 'outlined',
    'card--shadowed': kind === 'shadowed'
  }, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames,
    role: "presentation"
  }, divProps), children);
};

Card.propTypes = {
  kind: PropTypes.oneOf(['default', 'outlined', 'shadowed']),
  className: PropTypes.string,
  children: PropTypes.node,
  hover: PropTypes.bool
};
Card.defaultProps = {
  kind: 'default',
  hover: true
};
Card.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Card",
  "props": {
    "kind": {
      "defaultValue": {
        "value": "'default'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'default'",
          "computed": false
        }, {
          "value": "'outlined'",
          "computed": false
        }, {
          "value": "'shadowed'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "hover": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};
export default Card;